export const IconVariant = {
  Default: "default",
  Navigation: "navigation",
};
